<template>
<section class="ui-section uv-section">
    <div class="ui-max-width">
        <div class="txt-center">
            <div class="ui-head">
                <img src="../../assets/images/uv.png" alt="uvp" />
                <h3 v-html="$t('uvp_head')"></h3>
            </div>
        </div>
        <div class="ui-ts-text-wrap">
            <p>{{$t('uvp_p') }}</p>
        </div>
    </div>
</section>
</template>

<script>
export default {
 components: {}
}
</script>


<style lang="scss" scoped>
.uv-section {
    background: $secondary-color; // rgba(189, 69, 16, 0.12);
    background-image: url("../../assets/images/bg.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .ui-head{
        color: white;
    }

    img{
        max-width: 100px;
    }
}
/*EDIT COLOURS HERE*/

.ui-ts-heading {
    color: white;
}

.ui-ts-heading span {
    color: #39a8e3;
}

.ui-ts-subheading {
    color: #39a8e3;
}

.ui-ts-subheading {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.005em;
    text-align: left;
    margin-bottom: 8px;
}

.ui-ts-text-wrap {
    margin-left: 0;
    color: white;
    text-align: center;
}

.ui-ts-ul {
    list-style: disc;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ui-ts-ol {
    list-style: decimal;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ui-ts-li {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 6px;
    padding-left: 8px;
}
</style>
